var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-checkbox component"},[_c('UiBaseIcon',{staticClass:"ok",attrs:{"width":"8px","iconName":"done"}}),_vm._v(" "),_c('input',_vm._g({attrs:{"id":_vm.labelId,"type":"checkbox"},domProps:{"checked":_vm.checked}},_vm.listeners)),_vm._v(" "),_c('label',{attrs:{"for":_vm.labelId}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a43a28f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UiCheckbox.vue
// module id = null
// module chunks = 